import { Header, Segment } from '@mairistem/composants';

/**
 * Message barré par dessus le contenu
 */
const StripedMessage = ({ text, rotationCoef }: { text: string; rotationCoef: number }) => (
  <Segment
    basic
    style={{
      position: 'absolute',
      zIndex: 500,
      left: '50%',
      top: '50%',
      // Pas touche le calcul, c'est pour avoir à peu près en diagonal "tout le temps"
      transform: `translate(-50%, -50%) rotate(-${10 + rotationCoef * 6}deg)`,
      transformOrigin: '50% 50%',
      width: 5000,
      paddingTop: '3em',
      marginLeft: '-1.5em',
      marginRight: '-1.5em',
      opacity: 0.6,
    }}
    textAlign="center"
  >
    <Segment
      color="red"
      basic
      style={{
        width: '100%',
        borderWidth: 5,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Header
        style={{
          marginTop: -28,
          width: 'fit-content',
          background: 'white',
          paddingRight: 10,
          paddingLeft: 10,
        }}
      >
        {text}
      </Header>
    </Segment>
  </Segment>
);

export default StripedMessage;
